<template>
  <b-media
    href="test"
    vertical-align="center"
  >
    <template #aside>
      <b-avatar
        :size="size"
        :src="user.avatar"
        :text="avatarText(user.name)"
        variant="light-info"
      />
    </template>
    <span
      v-if="withInfo"
      class="font-weight-bold d-block text-nowrap"
    >
      {{ user.name }}
      <span v-if="user.source">({{ user.source }})</span>
    </span>
    <small
      v-if="withInfo"
      class="text-muted d-block"
      style="direction: ltr"
    >{{ user.mobile }}</small>
  </b-media>
</template>

<script>
import {
  BMedia, BAvatar,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'

export default {
  name: 'DisplayUser',
  components: {
    BMedia,
    BAvatar,
  },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    size: {
      type: [Number, String],
      default: () => 32,
    },
    withInfo: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      avatarText,
    }
  },
}
</script>

<style scoped></style>
